import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { SubmittalClientNotesState } from 'src/app/root-store/account-managers-submittals-store/state/submittals-clientnotes-state';

export const submittalClientNotesFeatureKey = 'submittal-clientnotes';

export const selectFeature = createFeatureSelector<SubmittalClientNotesState>(submittalClientNotesFeatureKey);

export const selectIsLoading = createSelector(selectFeature, (state) => state.isLoading === LoadingTypes.LOADING);

export const selectSubmittalClientNotesCandidates = createSelector(selectFeature,
    (state) => state.notes);

export const selectFilter = createSelector(selectFeature,
    (state) => state.submittalIds);
